import React from "react";
import { getLoggedinUser } from "./lib/axios-client";
import { Navigate } from "react-router-dom";

const AuthProtected = ({ children }) => {
  const isAuthenticated = !!getLoggedinUser();

  /*
    Navigate is un-auth access protected routes via url
    */
  if (!isAuthenticated) {
    return <Navigate to={{ pathname: "/auth/login" }} replace />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthProtected;
